import auVariables from "@skv/frontend/src/styles/au-variables.scss";
import baseTheme from "@skv/frontend/src/styles/jsvariables.scss";

import { timingFunctions } from "polished";
import { DefaultTheme } from "styled-components";

export const auTheme: DefaultTheme = Object.assign({}, baseTheme, auVariables, {
  timingFnEaseOut: timingFunctions("easeOutCubic"),
});
